
import React, { useEffect, useState } from 'react';
import { useRegistrationContext } from '../contexts/registrationContext'
import { uppercase } from '../services/utils/format'
import { useForm } from '../hooks/useForm'
import { strings } from "../assets/resources/translations"
import Checkbox from '../elements/Checkbox'
import Text from '../elements/Text'
import Textbox from '../elements/Textbox'

const init = {
	inputs: {
		comment: undefined,
		legalAgreement: undefined
	},
	rules: {
		legalAgreement: ["legal"]
	}
}


const Extra = ({ name, isDisabled, displayErrors }) => {
	const { config: { importantInformation, termsAndConditions }, wrapper: { updateInput, updateValidity } } = useRegistrationContext()

	const {
		inputs,
		errors,
		setInit,
		handleChange,
		isValid
	} = useForm(init)

	useEffect(() => {
		setInit(init)
	}, [])

	useEffect(() => {
		updateInput(name, inputs)
	}, [inputs])

	useEffect(() => {
		updateValidity(name, isValid)
	}, [isValid])

	return (
		<div>
			<div className="form-section section-grid">
				<span className="grid-first-column-only">
					<Textbox name="comment" label={uppercase(strings.comment)} value={inputs.comment} bold={true} rows="6" placeholder={strings.comment} error={errors.comment} onChange={handleChange} disabled={isDisabled} />
				</span>
			</div>
			<div className="form-section">
				<div className="information-box">
					<h3>{uppercase(strings.importantInformation)}</h3>
					{importantInformation && <div className="text" dangerouslySetInnerHTML={{ __html: importantInformation }} />}
					<div className="text" dangerouslySetInnerHTML={{ __html: strings.importantDescription }} />
					<br/>
					<div className="text" dangerouslySetInnerHTML={{ __html: strings.legalDescription }} />
					<div className="center">
						<Checkbox
							name="legalAgreement"
							label={termsAndConditions ? strings.legalAgreement + " " + termsAndConditions  : strings.legalAgreement}
							value={inputs.legalAgreement}
							error={errors.legalAgreement}
							disabled={isDisabled}
							onChange={handleChange}
							displayError={displayErrors}
						/>
					</div>
				</div>
			</div>

		</div>
	)
}

export default Extra